import { useQuery } from '@tanstack/react-query';

import { getContentfulImage } from '../utils';

const CONTENTFUL_STALE_TIME = 5 * 60 * 1000;
const CONTENTFUL_CACHE_TIME = 30 * 60 * 1000;

function useContentfulImage(slug: string) {
    const { data: imageUrl = null, isLoading } = useQuery(
        ['contentfulImage', slug],
        () => getContentfulImage(slug),
        {
            enabled: !!slug,
            staleTime: CONTENTFUL_STALE_TIME,
            cacheTime: CONTENTFUL_CACHE_TIME,
            refetchOnWindowFocus: false,
            refetchOnMount: false,
        }
    );

    return { imageUrl, isLoading: !!slug && isLoading };
}

export default useContentfulImage;
